import { create } from 'zustand'

/**
 * v0.8.57 — ticks each time `useRefreshOnFocus` re-reads the cloud, so
 * hook-local (non-store) data such as the recovery anchor can refetch too.
 * Store-backed data (debts, ledger) refreshes through its store's
 * `refresh()` instead.
 */
interface RemoteRefreshState {
  tick: number
  bump: () => void
}

export const useRemoteRefreshStore = create<RemoteRefreshState>()((set) => ({
  tick: 0,
  bump: () => set((s) => ({ tick: s.tick + 1 })),
}))
